import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callNavConfigureGetApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.navConfiguration);
  return data;
};